import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Popup } from 'next-common-lib';
import { getLanguage } from 'utils/cookies';
import * as popupActions from 'redux/ducks/common/popupDucks';

export const GuidePopup = ({ contents, imgName, title }) => {
  const dispatch = useDispatch();
  const isShowGuide = useSelector(state => state.popup.isShowGuide);
  const language = getLanguage();
  return (
    <>
      {isShowGuide && (
        <Popup
          id="guidePopup"
          isShow={isShowGuide}
          isDimed={isShowGuide}
          dimedClassName="transparent"
          zIndex={3000}
          isDimedOverlap
          size="md"
          componentType="normalPopup"
          useScroll={false}
          closeFunction={() => {
            dispatch(popupActions.closeGuide());
          }}
          headerComponent={[<h1 className="popup-title">{title}</h1>]}
          contentsComponent={[
            <>
              <div className="guide_area">{contents}</div>
              <div className={`guide_img ${imgName} ${language}`} />
            </>,
          ]}
        />
      )}
    </>
  );
};
GuidePopup.propTypes = {
  title: PropTypes.string.isRequired,
  contents: PropTypes.string.isRequired,
  imgName: PropTypes.string.isRequired,
};
GuidePopup.defaultProps = {};
export default GuidePopup;
